<template>
  <div>
    <vm-table ref="vmTable" url="mbs" :filter.sync="search" :loading="loading" @clear="clearDateRange">
      <template slot="adSearch">
        <vm-search :label="$l('maintWorkOrder.filter', '关键字检索')">
          <el-input v-model.trim="search.filter" :placeholder="$t('common.search')" clearable></el-input>
        </vm-search>
        <vm-search :label="$l('elevator.timeOfOccurrence', '发生时间')">
          <el-date-picker v-model="createTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
            :unlink-panels="true" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')"
            :end-placeholder="$t('common.endDate')" :default-time="['00:00:00', '23:59:59']" @change="handleDateChange">
          </el-date-picker>
        </vm-search>
      </template>
      <template slot="toolbar">
        <el-button :loading="exportLoading" class="greenBtn" @click="exportExcel">
          {{ $l("elevator.exportExcel", "导出") }}
        </el-button>
      </template>
      <el-table-column prop="elevatorNo" :label="$t('elevator.no')" width="125" align="center"></el-table-column>
      <el-table-column prop="elevatorName" :label="$t('elevator.name')"></el-table-column>
      <el-table-column prop="dtuCode" :label="$t('elevator.dtuCode')" width="130px" align="center"></el-table-column>
      <el-table-column prop="nodeCode" :label="$t('elevator.nodeCode')" :width="$l('110px', '90px')"
        align="center"></el-table-column>
      <el-table-column prop="useUnit" :label="$t('elevator.useUnit')"></el-table-column>
      <el-table-column :label="$l('elevator.gatewayPowerDown', '主电源断电')" align="center" :width="$l('160px', '100px')">
        <template v-slot="scope">
          <span v-if="$i18n.isCn">
            <el-tag type="success" v-if="scope.row.powerLoss">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </span>
          <span v-else>
            <el-tag type="success" v-if="scope.row.powerLoss">Yes</el-tag>
            <el-tag type="info" v-else>No</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column v-if="false" :label="$l('elevator.nonGateAreaStop', '非门区停止')" align="center"
        :width="$l('140px', '100px')">
        <template v-slot="scope">
          <span v-if="$i18n.isCn">
            <el-tag type="success" v-if="scope.row.nonDoorZoneStop">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </span>
          <span v-else>
            <el-tag type="success" v-if="scope.row.nonDoorZoneStop">Yes</el-tag>
            <el-tag type="info" v-else>No</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$l('elevator.alarmBell', '警铃报警')" align="center" :width="$l('140px', '100px')">
        <template v-slot="scope">
          <span v-if="$i18n.isCn">
            <el-tag type="success" v-if="scope.row.bellAlarm">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </span>
          <span v-else>
            <el-tag type="success" v-if="scope.row.bellAlarm">Yes</el-tag>
            <el-tag type="info" v-else>No</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$l('elevator.enterOutOfService', '进入停止服务')" align="center" :width="$l('160px', '110px')">
        <template v-slot="scope">
          <span v-if="$i18n.isCn">
            <el-tag type="success" v-if="scope.row.enterStopMode">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </span>
          <span v-else>
            <el-tag type="success" v-if="scope.row.enterStopMode">Yes</el-tag>
            <el-tag type="info" v-else>No</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column v-if="false" :label="$l('elevator.powerFailure', '主电源掉电')" :width="$l('140px', '100px')"
        align="center">
        <template v-slot="scope">
          <span v-if="$i18n.isCn">
            <el-tag type="success" v-if="scope.row.mainPowerLoss">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </span>
          <span v-else>
            <el-tag type="success" v-if="scope.row.mainPowerLoss">Yes</el-tag>
            <el-tag type="info" v-else>No</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$l('elevator.repair', '检修')" align="center" :width="$l('140px', '100px')">
        <template v-slot="scope">
          <span v-if="$i18n.isCn">
            <el-tag type="success" v-if="scope.row.repair">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </span>
          <span v-else>
            <el-tag type="success" v-if="scope.row.repair">Yes</el-tag>
            <el-tag type="info" v-else>No</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$l('elevator.timeOfOccurrence', '发生时间')" width="160px"
        align="center"></el-table-column>
    </vm-table>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      exportLoading: false,
      loading: false,
      createTime: [],
      search: {
        filter: "",
        beginTime: "",
        endTime: "",
      },
    };
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    getList(pageIndex) {
      this.loading = true;
      this.$refs.vmTable.getList(pageIndex);
      this.loading = false;
    },
    exportExcel() {
      if (this.createTime.length === 0) {
        this.$message.error(this.$l("common.fillThreeDays", "请先填写发生时间（三天之内）"));
        return;
      }
      let fullTime = [];
      for (let i = 0; i < this.createTime.length; i++) {
        let time = this.createTime[i].split(" ");

        let fullYear = time[0].split("-");
        let year = fullYear[0];
        let month = fullYear[1];
        let day = fullYear[2];

        let fullDay = time[1].split(":");
        let hour = fullDay[0];
        let minute = fullDay[1];
        let second = fullDay[2];

        let date = new Date(year, month, day, hour, minute, second);
        fullTime.push(date.getTime());
      }
      if (Math.ceil((fullTime[1] - fullTime[0]) / (24 * 3600 * 1000)) > 3) {
        this.$message.error(this.$l("common.withinThreeDays", "请填写三天之内的时间！"));
        return;
      }
      this.exportLoading = true;
      let params = {
        beginTime: this.createTime[0],
        endTime: this.createTime[1],
        filter: this.search.filter,
      };
      this.$api
        .exportFile("mbs/export", params, 60)
        .then(res => {
          this.exportLoading = false;
          let blob = new Blob([res.data]);
          let fileName = "";
          if (this.$i18n.isCn) {
            fileName = "MB记录.xlsx";
          } else {
            fileName = "MbEvent Info.xlsx";
          }
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        })
        .catch(() => {
          this.exportLoading = false;
        });
    },
    handleDateChange(dateRange) {
      if (dateRange != null) {
        this.search.beginTime = dateRange[0];
        this.search.endTime = dateRange[1];
      } else {
        this.search.beginTime = "";
        this.search.endTime = "";
      }
    },
    clearDateRange() {
      this.createTime = [];
    },
  },
};
</script>
<style lang="scss" scoped></style>
